import React from 'react';
import { withRouter } from 'react-router-dom'
import {connect} from 'react-redux';
import FlatButton from '../../components/FlatButton';
import { LoadWaitlistTemplatesEpic, AddWaitlistTemplateEpic, UpdateWaitlistTemplateEpic, DeleteWaitlistTemplateEpic } from "../../actions/waitlist.actions";
import ResourceList from '../../components/ResourceList';
import AddEditTemplateForm from './AddEditTemplateForm';

const styles = {
  contentBlock: {
      
  },
  contentLabel: {
    minWidth: '160px',
    fontWeight: '600'
  },
  notice: {
    background: 'lightyellow',
    padding: '5px'
  },
  section: {
    display: 'flex', 
    flexDirection: 'columns', 
    alignItems: 'left',
    marginBottom: '2em'
  }
};
export class WaitlistSettingsContainer extends React.Component {
  
  constructor(props){
    super(props);
    this.state = {
      showAddDialog:false,
      showEditDialog:false,
      selectedTemplate: null
    };
  }
  componentDidMount() {
    console.log('loading templates');
    this.props.loadTemplates(this.props.companyId);
  }

  getColumns = () => {
    return [
      {name: 'label', width: 150, label: 'Button Text'},
      {name: 'template', label: 'Message Text'},
      {name: 'details', width: 100, label: 'Action', render: (rowData) => <span><FlatButton onClick={() => this.showEditTemplate(rowData)} style={{minHeight: 40}} labelStyle={{fontSize: 18, fontWeight: '600', textTransform: 'capitalize'}} label='Edit' primary={true}/></span>}
    ];
  }

  getWelcomeColumns = () => {
    return [
      {name: 'template', label: 'Message Text'},
      {name: 'details', width: 100, label: 'Action', render: (rowData) => <span><FlatButton onClick={() => this.showEditTemplate(rowData)} style={{minHeight: 40}} labelStyle={{fontSize: 18, fontWeight: '600', textTransform: 'capitalize'}} label='Edit' primary={true}/></span>}
    ];
  }

  actionButton(props) {
    return <a style={{fontSize: '14px', fontWeight: 600, color: 'rgb(26, 181, 255)'}} onClick={props.onClick}>{props.label}</a>;
  }
  render() {
    return (
      <div style={{padding: '12px'}}>
        <div style={styles.section}>
          <div style={styles.contentLabel}>Confirmation Message</div>
          <div style={styles.contentBlock}>
            <p style={styles.notice}>This message will be sent to your guests as soon as they are added to the waitlist</p>
            <ResourceList columns={this.getWelcomeColumns()} data={this.props.welcomeTemplate? [this.props.welcomeTemplate] : []} showCheckboxes={false}/>
          </div>
        </div>
        <div style={styles.section}>
          <div style={styles.contentLabel}>Quick Messages</div>
          <div style={styles.contentBlock}>
            {this.props.templates.length < 5? <a style={{fontSize: '16px', fontWeight: 600, color: 'rgb(26, 181, 255)', cursor: 'pointer'}} onClick={() => this.newTemplate()}>+ New Message</a> : null}
            
            <p style={styles.notice}>Save your staff time by pre-composing text messages to send to guests</p>
            <span style={{float:'right'}}>{this.props.templates.length}/5 Messages</span><br/>
            <ResourceList columns={this.getColumns()} data={this.props.templates} showCheckboxes={false}/>
          </div>
        </div>
        {this.state.showAddDialog? <AddEditTemplateForm model={this.state.selectedTemplate} onSubmit={(data) => this.createTemplate(data)} onClose={() => this.handleDialogClose()} show={this.state.showAddDialog}/>:null}
        {this.state.showEditDialog? <AddEditTemplateForm model={this.state.selectedTemplate} onDelete={(data) => this.deleteTemplate(data)} onSubmit={(data) => this.updateTemplate(data)} onClose={() => this.handleDialogClose()} show={this.state.showEditDialog}/>:null}
      </div>
    );
  }

  newTemplate() {
    this.setState({showAddDialog: true, selectedTemplate: { label: '', template: '', company: this.props.companyId }});
  }

  showEditTemplate(data){
    this.setState({showEditDialog: true, selectedTemplate: data});
  }

  deleteTemplate(data){
    this.props.deleteTemplate(this.props.companyId, data);
    this.handleDialogClose();
  }

  createTemplate(data) {
    this.props.addTemplate(this.props.companyId, data);
    this.handleDialogClose();
  }

  updateTemplate(data) {
    this.props.updateTemplate(this.props.companyId, data);
    this.handleDialogClose();
  }

  handleDialogClose() {
    this.setState({showAddDialog: false, showEditDialog: false});
  }
}

let mapStateToProps = ({waitlistEndpoint, authEndpoint},{match}) => ({
  loading: waitlistEndpoint.fetchInProgress,
  error: waitlistEndpoint.fetchError? true:false,
  templates: waitlistEndpoint.templates ? waitlistEndpoint.templates : [],
  welcomeTemplate: waitlistEndpoint.welcomeTemplate,
  companyId: match.params.companyId? match.params.companyId : authEndpoint.company,
})

let mapDispatchToProps = (dispatch) => ({
  loadTemplates : (companyId) => dispatch(LoadWaitlistTemplatesEpic(companyId)),
  addTemplate: (companyId, templateData) => dispatch(AddWaitlistTemplateEpic(companyId, templateData)),
  updateTemplate: (companyId, templateData) => dispatch(UpdateWaitlistTemplateEpic(companyId, templateData)),
  deleteTemplate: (companyId, templateData) => dispatch(DeleteWaitlistTemplateEpic(companyId, templateData)),
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(WaitlistSettingsContainer));



// WEBPACK FOOTER //
// ./src/containers/Waitlist/WaitlistSettingsContainer.js